// ============================================================================
// PLAYER POSITIONS — All Active NBA Players (2025-26)
// ============================================================================

const PLAYER_POSITIONS = {
  // ATL
  'CJ McCollum': 'SG', 'Jalen Johnson': 'SF', 'Jonathan Kuminga': 'PF', 'Nickeil Alexander-Walker': 'SG',
  'Onyeka Okongwu': 'C', 'Corey Kispert': 'SF', 'Zaccharie Risacher': 'SF', 'Gabe Vincent': 'PG',
  'Buddy Hield': 'SG', 'Dyson Daniels': 'SG', 'Asa Newell': 'PF', 'Jock Landale': 'C',
  'Duop Reath': 'C', 'Mouhamed Gueye': 'PF', "N'Faly Dante": 'C', 'Keaton Wallace': 'PG',
  'Nikola Djurisic': 'SG', 'Caleb Houstan': 'SF', 'Ray J Dennis': 'PG', 'Eli Ndiaye': 'C',
  'Christian Koloko': 'C', 'Jacob Toppin': 'PF', 'David Roddy': 'SF', 'Malik Williams': 'PF',

  // BOS
  'Jayson Tatum': 'SF', 'Jaylen Brown': 'SG', 'Derrick White': 'SG', 'Nikola Vucevic': 'C',
  'Sam Hauser': 'SF', 'Payton Pritchard': 'PG', 'Hugo Gonzalez': 'PG', 'Baylor Scheierman': 'SF',
  'Luka Garza': 'C', 'Neemias Queta': 'C', 'Jordan Walsh': 'SF', 'Amari Williams': 'C',
  'John Tonje': 'SG', 'Ron Harper Jr.': 'SF', 'Max Shulga': 'PG', 'RJ Luis Jr.': 'SF',

  // BKN
  'Michael Porter': 'SF', 'Nicolas Claxton': 'C', 'Terance Mann': 'SG', 'Egor Demin': 'PG',
  'Ochai Agbaji': 'SG', "Day'Ron Sharpe": 'C', 'Ziaire Williams': 'SF', 'Cam Thomas': 'SG',
  'H. Highsmith': 'PF', 'Ben Simmons': 'PG', 'Killian Hayes': 'PG', 'Maxwell Lewis': 'SF',
  'Brandon Williams': 'PG', 'Trey Alexander': 'SG', 'Christian Braun': 'SG', 'Tyler Smith': 'PF',
  'Mohamed Diarra': 'PF',

  // CHA
  'Brandon Miller': 'SF', 'LaMelo Ball': 'PG', 'Mark Williams': 'C', 'Miles Bridges': 'PF',
  'Josh Green': 'SG', 'Grant Williams': 'PF', 'Tre Mann': 'PG', 'Nick Richards': 'C',
  'Moussa Diabate': 'PF', 'Cody Martin': 'SF', 'Tidjane Salaun': 'SF', 'Seth Curry': 'PG',
  'DaQuan Jeffries': 'SF', 'Taj Gibson': 'PF', 'KJ Simpson': 'PG', 'Leaky Black': 'SF',
  'Jaylen Sims': 'SG',

  // CHI
  'Zach LaVine': 'SG', 'Nikola Vucevic': 'C', 'Coby White': 'PG', 'Patrick Williams': 'PF',
  'Ayo Dosunmu': 'SG', 'Josh Giddey': 'PG', 'Talen Horton-Tucker': 'SG', 'Jalen Smith': 'PF',
  'Torrey Craig': 'SF', 'Dalen Terry': 'SG', 'Julian Phillips': 'SF', 'Matas Buzelis': 'SF',
  'Onuralp Bitim': 'SG', 'Kenneth Lofton Jr.': 'C', 'Marcus Domask': 'SF', 'Adam Mokoka': 'SG',
  'Adama Sanogo': 'C', 'Chris Duarte': 'SG',

  // CLE
  'Donovan Mitchell': 'SG', 'Darius Garland': 'PG', 'Evan Mobley': 'PF', 'Jarrett Allen': 'C',
  'Max Strus': 'SG', 'Caris LeVert': 'SG', 'Isaac Okoro': 'SF', 'Dean Wade': 'PF',
  'Sam Merrill': 'SG', 'Ty Jerome': 'PG', 'Georges Niang': 'PF', 'Luke Travers': 'SF',
  'Craig Porter Jr.': 'PG', 'Emoni Bates': 'SF', 'Jaylon Tyson': 'SG', 'Derrick Jones Jr.': 'SF',

  // DAL
  'Luka Doncic': 'PG', 'Klay Thompson': 'SG', 'PJ Washington': 'PF', 'Daniel Gafford': 'C',
  'Dereck Lively II': 'C', 'Kyrie Irving': 'PG', 'Quentin Grimes': 'SG', 'Naji Marshall': 'SF',
  'Dwight Powell': 'PF', 'Jaden Hardy': 'SG', 'Dante Exum': 'PG', 'Spencer Dinwiddie': 'PG',
  'Olivier-Maxence Prosper': 'PF', 'AJ Lawson': 'SG', 'Jazian Gortman': 'PG', 'Brandon Williams': 'PG',

  // DEN
  'Nikola Jokic': 'C', 'Jamal Murray': 'PG', 'Michael Porter Jr.': 'SF', 'Aaron Gordon': 'PF',
  'Russell Westbrook': 'PG', 'Christian Braun': 'SG', 'Julian Strawther': 'SG', 'Peyton Watson': 'SF',
  'Dario Saric': 'PF', 'Zeke Nnaji': 'PF', 'DeAndre Jordan': 'C', 'Hunter Tyson': 'SF',
  'DaRon Holmes II': 'PF', 'Jalen Pickett': 'PG', 'Trey Alexander': 'SG',

  // DET
  'Cade Cunningham': 'PG', 'Jaden Ivey': 'SG', 'Tobias Harris': 'PF', 'Ausar Thompson': 'SF',
  'Jalen Duren': 'C', 'Tim Hardaway Jr.': 'SG', 'Malik Beasley': 'SG', 'Simone Fontecchio': 'SF',
  'Isaiah Stewart': 'PF', 'Ron Holland II': 'SF', 'Wendell Moore Jr.': 'SG', 'Marcus Sasser': 'PG',
  'Bobi Klintman': 'PF', 'Ausar Thompson': 'SF', 'Isaiah Livers': 'PF',

  // GSW
  'Stephen Curry': 'PG', 'Andrew Wiggins': 'SF', 'Draymond Green': 'PF', 'Jonathan Kuminga': 'PF',
  'Kevon Looney': 'C', 'Buddy Hield': 'SG', 'Gary Payton II': 'SG', 'Al Horford': 'C',
  'Brandin Podziemski': 'SG', 'Trayce Jackson-Davis': 'PF', 'Moses Moody': 'SG', 'Gui Santos': 'SF',
  'Lindy Waters III': 'SF', 'Pat Spencer': 'PG', 'Quinten Post': 'C', 'Kevin Knox II': 'SF',
  'Reece Beekman': 'PG',

  // HOU
  'Jalen Green': 'SG', 'Alperen Sengun': 'C', 'Fred VanVleet': 'PG', 'Dillon Brooks': 'SF',
  'Jabari Smith Jr.': 'PF', 'Amen Thompson': 'SG', 'Tari Eason': 'PF', 'Reed Sheppard': 'PG',
  'Jeff Green': 'PF', 'Steven Adams': 'C', 'Cam Whitmore': 'SF', 'Jock Landale': 'C',
  'Aaron Holiday': 'PG', 'Nate Williams': 'SF',

  // IND
  'Tyrese Haliburton': 'PG', 'Pascal Siakam': 'PF', 'Myles Turner': 'C', 'Andrew Nembhard': 'PG',
  'Bennedict Mathurin': 'SG', 'Aaron Nesmith': 'SF', 'James Wiseman': 'C', 'TJ McConnell': 'PG',
  'Obi Toppin': 'PF', 'Isaiah Jackson': 'PF', 'Ben Sheppard': 'SG', 'Jarace Walker': 'PF',
  'Tristen Newton': 'PG', 'Enrique Freeman': 'PF', 'Johnny Furphy': 'SF',

  // LAC
  'Kawhi Leonard': 'SF', 'James Harden': 'PG', 'Norman Powell': 'SG', 'Ivica Zubac': 'C',
  'Terance Mann': 'SG', 'Derrick Jones Jr.': 'SF', 'Amir Coffey': 'SG', 'Bones Hyland': 'PG',
  'Kris Dunn': 'PG', 'P.J. Tucker': 'PF', 'Brook Lopez': 'C', 'Jordan Miller': 'SF',
  'KJ Martin': 'PF', 'Kai Jones': 'C', 'Kevin Porter Jr.': 'SG',

  // LAL
  'LeBron James': 'SF', 'Anthony Davis': 'PF', 'Austin Reaves': 'SG', 'DAngelo Russell': 'PG',
  'Rui Hachimura': 'PF', 'Dorian Finney-Smith': 'SF', 'Gabe Vincent': 'PG', 'Jarred Vanderbilt': 'PF',
  'Max Christie': 'SG', 'Jaxson Hayes': 'C', 'Dalton Knecht': 'SG', 'Bronny James': 'PG',
  'Christian Wood': 'C', 'Armel Traore': 'PF', 'Jake LaRavia': 'SF', 'Quincy Olivari': 'PG',

  // MEM
  'Ja Morant': 'PG', 'Desmond Bane': 'SG', 'Jaren Jackson Jr.': 'PF', 'Marcus Smart': 'PG',
  'Santi Aldama': 'PF', 'Brandon Clarke': 'PF', 'Luke Kennard': 'SG', 'John Konchar': 'SG',
  'Jake LaRavia': 'SF', 'Vince Williams Jr.': 'SG', 'Zach Edey': 'C', 'GG Jackson': 'SF',
  'Jay Huff': 'C', 'Scotty Pippen Jr.': 'PG', 'Jaylen Wells': 'SG', 'Cole Anthony': 'PG',

  // MIA
  'Jimmy Butler': 'SF', 'Bam Adebayo': 'C', 'Tyler Herro': 'SG', 'Terry Rozier': 'PG',
  'Duncan Robinson': 'SF', 'Nikola Jovic': 'PF', 'Jaime Jaquez Jr.': 'SF', 'Kevin Love': 'PF',
  'Haywood Highsmith': 'SF', 'Josh Richardson': 'SG', 'Kel\'el Ware': 'C', 'Pelle Larsson': 'SG',
  'Dru Smith': 'PG',

  // MIL
  'Giannis Antetokounmpo': 'PF', 'Damian Lillard': 'PG', 'Khris Middleton': 'SF', 'Brook Lopez': 'C',
  'Bobby Portis': 'PF', 'Pat Connaughton': 'SG', 'Gary Trent Jr.': 'SG', 'AJ Green': 'SG',
  'Taurean Prince': 'SF', 'Andre Jackson Jr.': 'SF', 'MarJon Beauchamp': 'SF', 'Ryan Rollins': 'PG',
  'Tyler Smith': 'PF', 'Liam Robbins': 'C', 'Delon Wright': 'PG',

  // MIN
  'Anthony Edwards': 'SG', 'Julius Randle': 'PF', 'Rudy Gobert': 'C', 'Jaden McDaniels': 'SF',
  'Mike Conley': 'PG', 'Nickeil Alexander-Walker': 'SG', 'Naz Reid': 'C', 'Donte DiVincenzo': 'SG',
  'Rob Dillingham': 'PG', 'Josh Minott': 'SF', 'Luka Garza': 'C', 'Leonard Miller': 'SF',
  'Joe Ingles': 'SF', 'Terrence Shannon Jr.': 'SG',

  // NOP
  'Zion Williamson': 'PF', 'Brandon Ingram': 'SF', 'CJ McCollum': 'SG', 'Dejounte Murray': 'PG',
  'Herbert Jones': 'SF', 'Trey Murphy III': 'SF', 'Jonas Valanciunas': 'C', 'Jose Alvarado': 'PG',
  'Jordan Hawkins': 'SG', 'Yves Missi': 'C', 'Javonte Green': 'SF', 'Jeremiah Robinson-Earl': 'PF',
  'Daniel Theis': 'C', 'Karlo Matkovic': 'C', 'Antonio Reeves': 'SG', 'Elfrid Payton': 'PG',
  'Kevon Looney': 'C',

  // NYK
  'Jalen Brunson': 'PG', 'Karl-Anthony Towns': 'C', 'OG Anunoby': 'SF', 'Mikal Bridges': 'SF',
  'Josh Hart': 'SG', 'Miles McBride': 'PG', 'Mitchell Robinson': 'C', 'Cameron Payne': 'PG',
  'Precious Achiuwa': 'PF', 'Landry Shamet': 'SG', 'Tyler Kolek': 'PG', 'Ariel Hukporti': 'C',
  'Kevin McCullar Jr.': 'SF', 'Pacôme Dadiet': 'SF', 'TJ Warren': 'SF',

  // OKC
  'Shai Gilgeous-Alexander': 'PG', 'Jalen Williams': 'SF', 'Chet Holmgren': 'C', 'Luguentz Dort': 'SG',
  'Isaiah Hartenstein': 'C', 'Alex Caruso': 'SG', 'Aaron Wiggins': 'SG', 'Kenrich Williams': 'PF',
  'Nikola Topic': 'PG', 'Isaiah Joe': 'SG', 'Ousmane Dieng': 'SF', 'Jaylin Williams': 'PF',
  'Ajay Mitchell': 'PG', 'Dillon Jones': 'SF', 'Adam Flagler': 'PG', 'Alex Ducas': 'SG',

  // ORL
  'Paolo Banchero': 'PF', 'Franz Wagner': 'SF', 'Jalen Suggs': 'PG', 'Wendell Carter Jr.': 'C',
  'Kentavious Caldwell-Pope': 'SG', 'Gary Harris': 'SG', 'Jonathan Isaac': 'PF', 'Cole Anthony': 'PG',
  'Moritz Wagner': 'C', 'Goga Bitadze': 'C', 'Jett Howard': 'SG', 'Tristan da Silva': 'SF',
  'Anthony Black': 'PG', 'Caleb Houstan': 'SF', 'Mac McClung': 'PG',

  // PHI
  'Joel Embiid': 'C', 'Tyrese Maxey': 'PG', 'Paul George': 'SF', 'Caleb Martin': 'SF',
  'Kelly Oubre Jr.': 'SG', 'Andre Drummond': 'C', 'Eric Gordon': 'SG', 'Kyle Lowry': 'PG',
  'KJ Martin': 'PF', 'Guerschon Yabusele': 'PF', 'Jared McCain': 'SG', 'Adem Bona': 'C',
  'Reggie Jackson': 'PG', 'Jeff Dowtin Jr.': 'PG', 'Ricky Council IV': 'SG',

  // PHX
  'Kevin Durant': 'SF', 'Devin Booker': 'SG', 'Bradley Beal': 'SG', 'Jusuf Nurkic': 'C',
  'Josh Okogie': 'SG', 'Grayson Allen': 'SG', 'Mason Plumlee': 'C', 'Royce ONeale': 'SF',
  'Ryan Dunn': 'SF', 'Monte Morris': 'PG', 'Oso Ighodaro': 'C', 'Collin Gillespie': 'PG',
  'Damion Lee': 'SG', 'TyTy Washington Jr.': 'PG',

  // POR
  'Anfernee Simons': 'SG', 'Jerami Grant': 'PF', 'Deandre Ayton': 'C', 'Deni Avdija': 'SF',
  'Scoot Henderson': 'PG', 'Robert Williams III': 'C', 'Toumani Camara': 'SF', 'Shaedon Sharpe': 'SG',
  'Donovan Clingan': 'C', 'Dalano Banton': 'PG', 'Matisse Thybulle': 'SF', 'Kris Murray': 'PF',
  'Duop Reath': 'C', 'Rayan Rupert': 'SG', 'Jabari Walker': 'PF',

  // SAC
  'DeMar DeRozan': 'SF', 'Domantas Sabonis': 'C', 'DeAaron Fox': 'PG', 'Keegan Murray': 'PF',
  'Malik Monk': 'SG', 'Kevin Huerter': 'SG', 'Trey Lyles': 'PF', 'Keon Ellis': 'SG',
  'Alex Len': 'C', 'Colby Jones': 'SG', 'Devin Carter': 'SG', 'Mason Jones': 'PG',
  'Orlando Robinson': 'C', 'Jordan McLaughlin': 'PG', 'Isaac Jones': 'PF',

  // SAS
  'Victor Wembanyama': 'C', 'Devin Vassell': 'SG', 'Keldon Johnson': 'SF', 'Jeremy Sochan': 'PF',
  'Tre Jones': 'PG', 'Zach Collins': 'C', 'Julian Champagnie': 'SF', 'Blake Wesley': 'PG',
  'Malaki Branham': 'SG', 'Sandro Mamukelashvili': 'PF', 'Chris Paul': 'PG', 'Harrison Barnes': 'SF',
  'Stephon Castle': 'PG', 'Riley Minix': 'PF', 'Jamaree Bouyea': 'PG', 'Harrison Ingram': 'SF',
  'David Duke Jr.': 'SG',

  // TOR
  'Scottie Barnes': 'SF', 'RJ Barrett': 'SG', 'Immanuel Quickley': 'PG', 'Jakob Poeltl': 'C',
  'Gradey Dick': 'SG', 'Kelly Olynyk': 'PF', 'Ochai Agbaji': 'SG', 'Bruce Brown': 'SG',
  'Chris Boucher': 'PF', 'Davion Mitchell': 'PG', 'Garrett Temple': 'SG', 'Ja\'Kobe Walter': 'SG',
  'Jonathan Mogbo': 'PF', 'Jamal Shead': 'PG', 'Ulrich Chomche': 'C',

  // UTA
  'Lauri Markkanen': 'PF', 'Jordan Clarkson': 'SG', 'John Collins': 'PF', 'Collin Sexton': 'PG',
  'Walker Kessler': 'C', 'Keyonte George': 'PG', 'Brice Sensabaugh': 'SF', 'Cody Williams': 'SF',
  'Kyle Filipowski': 'PF', 'Patty Mills': 'PG', 'Drew Eubanks': 'C', 'Isaiah Collier': 'PG',
  'Svi Mykhailiuk': 'SG', 'Oscar Tshiebwe': 'C', 'Taylor Hendricks': 'PF', 'Micah Potter': 'C',

  // WAS
  'Kyle Kuzma': 'PF', 'Malcolm Brogdon': 'PG', 'Jordan Poole': 'SG', 'Jonas Valanciunas': 'C',
  'Bilal Coulibaly': 'SF', 'Corey Kispert': 'SF', 'Alex Sarr': 'C', 'Kyshawn George': 'SF',
  'Bub Carrington': 'PG', 'Saddiq Bey': 'SF', 'Justin Champagnie': 'PF', 'Richaun Holmes': 'C',
  'Jared Butler': 'PG', 'Johnny Davis': 'SG', 'Patrick Baldwin Jr.': 'SF', 'Jules Bernard': 'SG',
};

export function getPlayerPosition(name) {
  return PLAYER_POSITIONS[name] || null;
}

export default PLAYER_POSITIONS;
